module.exports = __webpack_public_path__ + "img/full2-min.6663b0e1.png";